import colorConstant from 'common/styles/styles.colors';
import { themedStyled } from 'common/styles/styletron.theme';
import Text from 'components/elements/text';
export const DescriptionText = themedStyled(Text, {
  color: '#A39F96',
});

export const Tag = themedStyled('span', {
  backgroundColor: 'white',
  color: colorConstant.primaryDefault,
  borderRadius: '24px',
  border: `2px solid ${colorConstant.primaryDefault}`,
  padding: '4px 8px',
});
